import { useEffect, useState } from 'react';

import gtmClient from '~/services/gtm.client';
import type { Region } from '~/utils/region';

import { Button, ExternalLink } from './Button';
import { Dialog } from './Dialog';

type Props = {
  path: string;
  targetRegion: Region;
};

export default function RegionSwitch({ targetRegion, path }: Props) {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const regionOptOut = localStorage?.getItem('regionOptOut') === 'true';

    setIsOpen(!regionOptOut);
  }, []);

  const handleStayOnUK = () => {
    gtmClient.trackedButtonClick({
      buttonName: 'STAY_ON_UK',
      pagePosition: 'REGION_SWITCH'
    });

    localStorage.setItem('regionOptOut', 'true');
    setIsOpen(false);
  };

  const handleGoToTargetRegion = () => {
    gtmClient.trackedButtonClick({
      buttonName: 'GO_TO_REGION',
      pagePosition: 'REGION_SWITCH'
    });
  };

  return (
    <Dialog
      isOpen={isOpen}
      onDismiss={() => setIsOpen(false)}
      className="fixed inset-x-0 bottom-0 w-full bg-black px-4 py-8 text-white"
    >
      <div className="mx-auto flex w-full max-w-screen-xl flex-col gap-6 lg:flex-row lg:items-center lg:justify-between lg:gap-8">
        <div className="flex flex-col gap-2 lg:max-w-md">
          <h2 className="text-2xl">
            It looks like you're visiting us from {targetRegion.name}!
          </h2>
          <p>
            Would you like to continue on our {targetRegion.adjective} site or
            stay on the UK site?
          </p>
        </div>

        <div className="mt-4 flex w-full flex-col gap-4 lg:mt-0 lg:w-auto lg:flex-row lg:items-center lg:gap-6">
          <Button
            onClick={handleStayOnUK}
            variant="black"
            className="border border-white lg:w-72"
          >
            🇬🇧 Stay on the UK website
          </Button>
          <ExternalLink
            variant="green-human"
            href={`${targetRegion.baseUrl}${path}?regionSwitch=true`}
            className="lg:w-72"
            onClick={handleGoToTargetRegion}
          >
            {targetRegion.flag} Go to the {targetRegion.adjective} website
          </ExternalLink>
        </div>
      </div>
    </Dialog>
  );
}
